<template lang="pug">
  section.login.bars
    header.login__header
      login-logo

    main.login__main
      router-view(
        :loading-text="password ? $t('password.sending') : $t('login.logging')")
</template>

<script>
import LoginLogo from '@/components/login/LogoOnesait'
import { mapGetters } from 'vuex'
import LangSelector from '@/components/shared/LangSelector'

export default {
  name: 'Login',
  components: {
    LangSelector,
    LoginLogo
  },
  computed: {
    ...mapGetters({
      password: 'getIsPasswordForm'
    })
  }
}

</script>

<style lang="scss" >
.login {
  height: 100vh;
  display: flex;
  flex-direction: column;
  color: var(--color-txt-primary);
  background-color: var(--color-bg-primary);

  &__header {
    padding: $space-300;
    width: 100%;
    border-bottom: $border-size-200 solid var(--color-border-hard-divisor);
    text-align: center;

    & > svg path {
      fill: var(--color-txt-primary);;
    }

    &__theme-selector {
      position: absolute;
      right: rem(20);
      top: rem(20);
    }
  }

  &__main {
    padding: $space-300;
    display: flex;
    justify-content: center;
    width: 100%;
    flex: 1;
  }
}

</style>
